var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.currentStep
        ? _c("Stepper", {
            ref: "stepper",
            attrs: {
              steps: _vm.stepSequence,
              selectableOptions: _vm.selectableOptions,
              stepNumber: _vm.stepNumber,
              id: "stepper",
              title: _vm.getTitle,
              currentStep: _vm.currentStep,
              continueBtn: {
                show: _vm.currentStep.continue,
                disabled:
                  !_vm.experienceValid ||
                  !_vm.emailValid ||
                  !_vm.validClientInfo ||
                  !_vm.capacityValid ||
                  !_vm.offSiteLocationValid,
              },
              saveBtn: {
                show: _vm.currentStep.saveBtn,
                disabled:
                  !_vm.experienceValid ||
                  !_vm.emailValid ||
                  !_vm.validClientInfo ||
                  !_vm.capacityValid ||
                  !_vm.offSiteLocationValid,
              },
              paymentBtn: {
                loading: _vm.loading,
              },
              formLoadingProp: _vm.form.processing,
              apiLoading: _vm.apiLoading && _vm.currentStep?.showLoading,
              flat: _vm.flat,
              relative: _vm.relative,
              permanent: _vm.permanent,
              cardBody: _vm.cardBody,
            },
            on: {
              jumpToStep: function ($event) {
                return _vm.jumpToStep($event)
              },
              nextStep: function ($event) {
                return _vm.nextStep()
              },
              continueBtn: function ($event) {
                return _vm.continueBtn()
              },
              paymentBtn: function ($event) {
                return _vm.$refs.payment.submitManualCard()
              },
              backStep: function ($event) {
                return _vm.backStep()
              },
              submit: function ($event) {
                return _vm.submit()
              },
              reset: function ($event) {
                return _vm.$_data_reset()
              },
              saveInnerForm: function ($event) {
                return _vm.saveInnerForm()
              },
            },
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.selectableOptions, function (step) {
                  return {
                    key: step.name,
                    fn: function () {
                      return [
                        _vm.currentStep.name == step.name
                          ? _c(
                              step.comp,
                              _vm._g(
                                _vm._b(
                                  {
                                    key: step.name,
                                    tag: "component",
                                    class: step.classes,
                                    model: {
                                      value: _vm.form[step.name],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, step.name, $$v)
                                      },
                                      expression: "form[step.name]",
                                    },
                                  },
                                  "component",
                                  { ...step.props() },
                                  false
                                ),
                                step.on
                              )
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  }
                }),
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.alerts, function (alert) {
        return _c(
          "div",
          { key: alert?.subtitle },
          [
            alert
              ? _c(
                  "SoliChoice",
                  {
                    ref: "alert",
                    refInFor: true,
                    attrs: {
                      title: alert.title,
                      subtitle: alert.subtitle,
                      button1: alert.button1,
                      button2: alert.button2,
                      warning: alert.warning,
                      permanent: alert.permanent,
                    },
                    on: {
                      option1: function ($event) {
                        return alert.option1()
                      },
                      option2: function ($event) {
                        return alert.option2()
                      },
                    },
                  },
                  [
                    [
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        _vm._l(_vm.futureBookingConflict, function (conflict) {
                          return _c(
                            "v-list-item",
                            { key: conflict.starts_at },
                            [
                              _c("small", { staticClass: "soli-grey" }, [
                                _vm._v(
                                  _vm._s(
                                    `· ${
                                      conflict.type
                                    } on ${_vm.globalMomentDate(
                                      conflict.starts_at
                                    )}`
                                  )
                                ),
                              ]),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }